// request call video to patients
export const CONSULT_GET_VIDEO_ROOM_REQUESTED = 'CONSULT_GET_VIDEO_ROOM_REQUESTED';
export const CONSULT_GET_VIDEO_ROOM_SUCCEED = 'CONSULT_GET_VIDEO_ROOM_SUCCEED';
export const CONSULT_GET_VIDEO_ROOM_FAILED = 'CONSULT_GET_VIDEO_ROOM_FAILED';

export const CONSULT_END_VIDEO_ROOM_REQUESTED = 'CONSULT_END_VIDEO_ROOM_REQUESTED';
export const CONSULT_END_VIDEO_ROOM_SUCCEED = 'CONSULT_END_VIDEO_ROOM_SUCCEED';
export const CONSULT_END_VIDEO_ROOM_FAILED = 'CONSULT_END_VIDEO_ROOM_FAILED';

export const CONSULT_CLOSE_ALL_VIDEO_ROOM_REQUESTED = 'CONSULT_CLOSE_ALL_VIDEO_ROOM_REQUESTED';
export const CONSULT_CLOSE_ALL_VIDEO_ROOM_SUCCEED = 'CONSULT_CLOSE_ALL_VIDEO_ROOM_SUCCEED';
export const CONSULT_CLOSE_ALL_VIDEO_ROOM_FAILED = 'CONSULT_CLOSE_ALL_VIDEO_ROOM_FAILED';

export const CONSULT_GET_ONGOING_CALL_REQUESTED = 'CONSULT_GET_ONGOING_CALL_REQUESTED';
export const CONSULT_GET_ONGOING_CALL_SUCCEED = 'CONSULT_GET_ONGOING_CALL_SUCCEED';
export const CONSULT_GET_ONGOING_CALL_FAILED = 'CONSULT_GET_ONGOING_CALL_FAILED';

export const ZOOM_EVENTS_REQUESTED = 'ZOOM_EVENTS_REQUESTED';
export const ZOOM_EVENTS_SUCCEED = 'ZOOM_EVENTS_SUCCEED';
export const ZOOM_EVENTS_FAILED = 'ZOOM_EVENTS_FAILED';

export const ZOOM_VIDEO_TRANSCRIPT_REQUESTED = 'ZOOM_VIDEO_TRANSCRIPT_REQUESTED';
export const ZOOM_VIDEO_TRANSCRIPT_SUCCEED = 'ZOOM_VIDEO_TRANSCRIPT_SUCCEED';
export const ZOOM_VIDEO_TRANSCRIPT_FAILED = 'ZOOM_VIDEO_TRANSCRIPT_FAILED';

export const ZOOM_VIRTUAL_BACKGROUND_LIST_REQUESTED = 'ZOOM_VIRTUAL_BACKGROUND_LIST_REQUESTED';
export const ZOOM_VIRTUAL_BACKGROUND_LIST_SUCCEED = 'ZOOM_VIRTUAL_BACKGROUND_LIST_SUCCEED';
export const ZOOM_VIRTUAL_BACKGROUND_LIST_FAILED = 'ZOOM_VIRTUAL_BACKGROUND_LIST_FAILED';

export const VIDEO_TRIGGER_OPEN = 'VIDEO_TRIGGER_OPEN';
export const VIDEO_TRIGGER_CLOSE = 'VIDEO_TRIGGER_CLOSE';
